// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

import Validation from '../../utils/Validation';

import ProDomainsList from './ProDomainsList';
import ProRole from './ProRole';

import RestaurantsGroup from '../restaurantsGroup/RestaurantsGroup';

/**
 * Represents an account for a B2B user of PayMyTable. An Account should be unique for each person.
 * A person can have an Account containing multiple Domains.
 */
export default class ProAccount extends ApiObject {

  static MINIMUM_PASSWORD_LENGTH = 6;

  // long
  id;

  firstName: string;

  lastName: string;

  email: String;

  password: string;

  passwordVerification: string;

  elevationCode: string;

  activated: boolean;

  /**
   * The Api does no send the domains list with the pro account object.
   * We have to retrieve it later.
   *
   * front only
   */
  domainsList: ProDomainsList = null;

  // restaurantsGroup: RestaurantsGroup = null;

  /**
   * Front only
   */
  role: ?ProRole = null;

  postJsonAssignation(data) {
    if (!_.isNull(data.domainsList)) {
      this.domainsList = new ProDomainsList();
      this.domainsList.fromJson(data.domainsList);
    }
  }

 /**
  * Do not handle password here, we don't want to return false if the user does not want to change
  * the password.
  * Note: elevationCode isn't required for now.
  * @See isValidPassword
  */
  isValid(): boolean {
    return !_.isEmpty(this.firstName)
    && !_.isEmpty(this.lastName)
    && !_.isEmpty(this.email)
    && Validation.email(this.email);
  }

  isValidPassword(): boolean {
    return !_.isEmpty(this.password)
     && this.password === this.passwordVerification
     && this.password.length >= ProAccount.MINIMUM_PASSWORD_LENGTH;
  }

  getName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

}
